// src/locales/en/warehouses.js
export const warehouses = {
    // Navigation
    createNewWarehouse: "Create New Warehouse",
    setupYourWarehouse: "Set up your warehouse details and information",
    backToWarehouses: "Back to Warehouses",
    
    // Form Fields
    basicInformation: "Basic Information",
    basicInformationDesc: "Provide basic details about your warehouse",
    warehouseName: "Warehouse Name",
    warehouseNamePlaceholder: "Enter warehouse name (e.g., Main Warehouse, Storage Unit A)",
    addressPlaceholder: "Enter complete warehouse address...",
    addressHint: "Include street address, city, and postal code for better identification",
    phonePlaceholder: "Enter contact number",
    phoneHint: "Contact number for warehouse operations and coordination",
    phone: "Phone Number",
    address: "Address",
    
    // Validation Messages
    nameRequired: "Warehouse name is required",
    nameMinLength: "Warehouse name must be at least 2 characters",
    invalidPhone: "Please enter a valid phone number",
    
    // Actions
    createWarehouse: "Create Warehouse",
    
    // Success/Error Messages
    warehouseCreatedSuccess: "Warehouse '{{warehouseName}}' created successfully!",
    failedToCreate: "Failed to create warehouse. Please try again.",

    // Warehouses List Page (for future implementation)
    manageYourWarehouses: "Manage all your warehouses and their information",
    loadingWarehouses: "Loading Warehouses...",
    loadingWarehousesDesc: "Please wait while we fetch your warehouses.",
    searchWarehouses: "Search warehouses by name, address, or phone...",
    filteredResults: "{{count}} of {{total}} warehouses",
    totalWarehouses: "{{count}} warehouses",
    allWarehouses: "All Warehouses",
    noSearchResults: "No warehouses found",
    noSearchResultsDesc: "Try adjusting your search terms or clear filters to see all warehouses.",
    noWarehouses: "No warehouses yet",
    noWarehousesDesc: "Create your first warehouse to start managing your inventory locations.",
    createFirstWarehouse: "Create First Warehouse",

    // Additional translations for manage page
    addWarehouse: "Add Warehouse",
    editWarehouse: "Edit Warehouse",
    updateWarehouse: "Update Warehouse",
    warehouseUpdatedSuccess: "Warehouse '{{warehouseName}}' updated successfully!",
    failedToUpdate: "Failed to update warehouse. Please try again.",
    failedToLoadWarehouse: "Failed to load warehouse details. Please try again.",

    // Table Headers
    contact: "Contact",
    
    // Table Content
    noContact: "No contact info",
    
    // Actions
    confirmDelete: "Are you sure you want to delete the warehouse '{{warehouseName}}'? This action cannot be undone.",
    warehouseDeletedSuccess: "Warehouse '{{warehouseName}}' has been deleted successfully.",
    failedToDelete: "Failed to delete warehouse. Please try again."
}